export enum UserRequest {
  DELETE,
}
